import * as Yup from "yup";
import {
  getRequiredDateForCondition, getRequiredStringForCondition,
  yupRequiredPositiveNumber,
  yupRequiredString
} from "../yup/Validators";

export const BookingForPurchaseCreationValidationSchema = Yup.object().shape({
  quantity: yupRequiredPositiveNumber,
  supplierId: yupRequiredString,
})

const supportingFileUploaded = (file) => !!file;

export const BookingDocumentFormValidationSchema = () =>
  Yup.object().shape({
    paymentDate: getRequiredDateForCondition("atLeastOnePaymentFile", (atLestOnePaymentFile: boolean) => !!atLestOnePaymentFile),
    supportingFileType: getRequiredStringForCondition("supportingFile", supportingFileUploaded)
  });
